import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { removeFavorite } from '../../actions/favoriteEntities';
import { ResultsMobile } from '../../components/ResultsMobile';
import { isFavoritesForAuthorizationEnabled } from '../../selectors/experiments/isFavoritesForAuthorizationEnabled';
import { IApplicationState } from '../../types/redux';
import { ResultsEmptyForAuthorizationContainer } from '../ResultsEmptyForAuthorizationContainer';

export const ResultsMobileContainer = () => {
  const results = useSelector((state: IApplicationState) => state.results);
  const page = useSelector((state: IApplicationState) => state.page);
  const favoritesForAuthorizationEnabled = useSelector(isFavoritesForAuthorizationEnabled);

  const dispatch = useDispatch();

  const handleClick = React.useCallback((entityId: number) => {
    dispatch(removeFavorite({ entityId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (favoritesForAuthorizationEnabled) {
      dispatch(requestAuthentication());
    }
  }, [dispatch, favoritesForAuthorizationEnabled]);

  if (!results.favoriteEntities.length) {
    return null;
  }

  if (favoritesForAuthorizationEnabled) {
    return <ResultsEmptyForAuthorizationContainer />;
  }

  return <ResultsMobile results={results} page={page} removeFavorite={handleClick} />;
};
